import type { DealEventTct } from '@dealstack/shared/lib/backendClient';
import { normalizeScreamingSnakeToUI } from '@dealstack/shared/lib/format/string';
import { formatTableNameToLabel } from '@dealstack/frontend/shared/components/Audit/AuditLayout/utils.ts';
import {
	formatAccessHeading,
	formatAuthHeading,
	formatEventActionLabel,
} from '@dealstack/frontend/app/pages/Project/DealEventLog/dealEventLog.utils.ts';

type Translate = (key: string) => string;

export const formatEventTypeLabel = (event: DealEventTct, t: Translate): string => {
	if (event.auth) {
		return formatAuthHeading(event.auth.action, t);
	}

	if (event.access) {
		return formatAccessHeading(event.access.action, t);
	}

	const entity = formatTableNameToLabel(event.entity.type, t);

	return entity === event.entity.type
		? normalizeScreamingSnakeToUI(event.type)
		: `${entity} · ${formatEventActionLabel(event.action, t)}`;
};
